
const defaultLocale = navigator.language && navigator.language.substr(0, 2).toLowerCase();

export default {
  Intl: {
    locale:
      defaultLocale === 'pt' || defaultLocale === 'es' || defaultLocale === 'en' 
        ? defaultLocale 
            : 'en'
  }
};
